import React, { useRef, useState } from 'react';
import { Modal } from 'antd';
import type { DraggableData, DraggableEvent } from 'react-draggable';
import Draggable from 'react-draggable';

interface Props {
  title?: string;
  children: React.ReactNode;
  open: boolean;
  setOpen?: (e: boolean) => {};
  footer?: any;
  width?: number;
  onCancel: any;
  maskClosable?: boolean;
  destroyOnClose?: boolean;
  loading?: boolean;
}

const DraggableModal: React.FC<Props> = (props) => {
  const {
    title,
    children,
    open,
    setOpen,
    footer = null,
    width = 900,
    onCancel,
    loading = false,
    ...rest
  } = props;
  const [disabled, setDisabled] = useState(true);
  const [bounds, setBounds] = useState({
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
  });

  const draggleRef = useRef<HTMLDivElement>(null!);

  const handleOk = () => {
    setOpen && setOpen(false);
  };

  const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = draggleRef.current?.getBoundingClientRect();
    if (!targetRect) {
      return;
    }
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    });
  };

  return (
    <>
      <Modal
        {...rest}
        onCancel={onCancel}
        title={
          <div
            style={{ width: '100%', cursor: 'move' }}
            onMouseOver={() => {
              if (disabled) {
                setDisabled(false);
              }
            }}
            onMouseOut={() => {
              setDisabled(true);
            }}
            onFocus={() => {}}
            onBlur={() => {}}
          >
            {title}
          </div>
        }
        // height={'100%'}
        loading={loading}
        footer={footer}
        open={open}
        width={width}
        onOk={handleOk}
        maskClosable={false}
        modalRender={(modal) => (
          <Draggable
            disabled={disabled}
            bounds={bounds}
            nodeRef={draggleRef}
            onStart={(event, uiData) => onStart(event, uiData)}
          >
            <div ref={draggleRef}>{modal}</div>
          </Draggable>
        )}
      >
        {children}
      </Modal>
    </>
  );
};

export default DraggableModal;
